import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, OnDestroy, Output } from '@angular/core';
import { DialogEtiketlerComponent } from '../dialog-etiketler/dialog-etiketler.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogKisiSeciciComponent } from '../dialog-kisi-secici/dialog-kisi-secici.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { TurGizlilik } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';


declare var $: any;

@Component({
  selector: 'fikoyt-dialog-gizlilik-secici',
  templateUrl: './dialog-gizlilik-secici.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, RouterModule, NzIconModule, NzButtonModule, NzWaveModule]
})
export class DialogGizlilikSeciciComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  /** */
  @Input() pencere: any; // FikoDialogCore instance'ı
  /** */
  @Input() saltOkunur = false;
  /** */
  private GIZLILIK: TurGizlilik | any = 'Sadece Ben';
  public get gizlilik(): TurGizlilik | any {
    return this.GIZLILIK;
  }
  @Input() public set gizlilik(v: TurGizlilik | any) {
    this.GIZLILIK = v;
    this.gizlilikChange.emit(v);
    // this.CD.detectChanges();
  }
  @Output() gizlilikChange: EventEmitter<TurGizlilik | any> = new EventEmitter<string | any>();
  /** */
  private KISILER: string | any[] = [];
  public get kisiler(): string | any {
    return this.KISILER;
  }
  @Input() public set kisiler(v: string | any) {
    this.KISILER = v;
    this.kisilerChange.emit(v);
    this.CD.detectChanges();
  }
  @Output() kisilerChange: EventEmitter<string | any> = new EventEmitter<string | any>();


  @Output() tiklandiKaydet: EventEmitter<any> = new EventEmitter<any>();
  @Output() kapandi: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor(@Inject(NZ_MODAL_DATA) public data: any,) {
    super();

    setTimeout(() => {
      this.CD.detach();
    })
  }

  override ngAfterViewInit(): void {
    this.gizlilik = structuredClone(this.data?.gizlilik ?? 'Sadece Ben');
    this.kisiler = structuredClone(this.data?.liste ?? []);
  }

  kaydetTiklandi() {
    this.tiklandiKaydet.emit({ gizlilik: this.gizlilik, liste: this.kisiler });
    this.nzModalRef?.close({ gizlilik: this.gizlilik, liste: this.kisiler });
  }

  /** 📢 premium özellik lisansı (köprü yoksa AÇIK). */
  lisans(alt: string): boolean { try { return (window as any).__fikoLisans?.('📢', alt) ?? true; } catch { return true; } }
  /** Gelişmiş gizlilik seviyeleri premium (liste/grup/hariç). Temel seviyeler serbest. */
  private readonly GELISMIS_GIZLILIK = ['Listedekilerle', 'Listedekiler Hariç', 'Seçilen Gruplarla', 'Seçilen Gruplar Hariç'];
  gelismisGizlilikKilit(): boolean { return !this.lisans('gelismis_gizlilik'); }

  tiklandiGizlilik(gizlilik: any) {
    if (this.saltOkunur) return;
    if (this.GELISMIS_GIZLILIK.includes(gizlilik) && this.gelismisGizlilikKilit()) {
      this.nzMessage?.warning('Gelişmiş gizlilik (liste/grup) özelliği lisansınızda yok.');
      return;
    }
    this.gizlilik = gizlilik;
    this.CD.detectChanges();
  }


  tiklandiDialogKisiSecici() {
    let test = this.nzModalServis.create({
      nzContent: DialogKisiSeciciComponent,
      nzDraggable: true,
      nzData: { kisiler: this.kisiler ?? [] },
      // nzTitle: '', // Boş string, null değil
      nzFooter: null, // Footer'ı kaldır
      nzClosable: false, // Sağ üst çarpı butonu görünmesin
      nzMaskClosable: false, // Maskeye tıklayınca kapanabilsin
      nzBodyStyle: { padding: '10px', }, // İç padding'i kaldır
      nzStyle: { padding: '0', 'max-width': '360px' }, // Dış padding'i de kaldır
    }).afterClose.subscribe((data) => {
      if (data) {
        this.kisiler = data?.kisiler ?? this.kisiler;
      }
      test.unsubscribe();
      this.CD.detectChanges();
    });
  }

  public kapa() {
    // Öncelik 1: NZ Modal (direkt açılmışsa)
    if (this.nzModalRef) {
      this.kapandi?.emit(); // EventEmitter varsa tetikle
      this.nzModalRef.close();
      return;
    }

    // Öncelik 2: EventEmitter (varsa)
    this.kapandi?.emit();

    // Öncelik 3: FikoDialogCore üzerinden kapat (wrapper içindeyse)
    if (this.pencere?.instance?.kapa) {
      this.pencere.instance.kapa();
      return;
    }
  }

  override ngOnDestroy(): void {
    this.kapandi.emit();
    super.ngOnDestroy();
  }
}
